<div style="display: flex; justify-content: flex-end;">
  <button type="button" class="btn-close" [mat-dialog-close]=""></button>
</div>
<div class="container-fluid" *ngIf="!loading; else loadingbar">
  <div *ngIf="receipt; else note">
    <h1 mat-dialog-title class="m-0">Envío #{{ receipt.trackingNumber }}</h1>
    <hr />
    <div [class]="(receipt.photoURL || receipt.recipient_photo_url) ? 'row' : ''">
      <div [class]="(receipt.photoURL || receipt.recipient_photo_url) ? 'col-md-6 col-12 mb-3' : 'col-12 mb-3'">
        <mat-card class="mat-elevation-z4">
          <mat-card-header>
            <mat-card-title class="mt-4">Detalles de {{ receipt.recipient?'última milla':'recolección' }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-list>
              <mat-list-item *ngIf="receipt.textRegDate && receipt.service === 'pickup'">
                <span>Fecha de recolección: {{ receipt.textRegDate }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="receipt.name && receipt.service === 'pickup'">
                <mat-icon>person</mat-icon>
                <span class="receipt-element"> Recolectó: {{ receipt.name }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="receipt.phone && receipt.service === 'pickup'">
                <mat-icon>phone</mat-icon>
                <span class="receipt-element"> {{ (receipt.phone) ? receipt.phone : 'No registrado' }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="receipt.email && receipt.service === 'pickup'">
                <mat-icon>email</mat-icon>
                <span class="receipt-element"> {{ (receipt.email) ? receipt.email : 'No registrado' }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="receipt.recipient">
                <span>Fecha de entrega: {{ receipt.delivered_at }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="receipt.recipient">
                <mat-icon>person</mat-icon>
                <span class="receipt-element"> Recibió: {{ receipt.recipient }}</span>
              </mat-list-item>
            </mat-list>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6 col-12 mb-3" *ngIf="receipt.photoURL || receipt.recipient_photo_url">
        <!-- Si no es de última milla, muestra solo una evidencia -->
        <div *ngIf="!receipt.recipient && receipt.photoURL; else lastMileEvidence">
          <div class="receipt-suptext">
            <mat-icon>aspect_ratio</mat-icon> <span class="receipt-element">Evidencia:</span>
          </div>
          <div class="image-container">
            <img [src]="receipt.photoURL" alt="Evidencia">
          </div>
        </div>
        <!-- Si es de última milla, muestra ambas evidencias -->
        <ng-template #lastMileEvidence>
            <div *ngIf="receipt.recipient_photo_url">
              <div class="receipt-suptext">
                <mat-icon>aspect_ratio</mat-icon> <span class="receipt-element">Evidencia de entrega:</span>
              </div>
              <div class="image-container">
                <img [src]="receipt.recipient_photo_url" alt="Evidencia de entrega">
              </div>
            </div>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template #note>
    <div class="note-block my-4">
      <p class="note">No se encontró la evidencia para este envío.</p>
    </div>
  </ng-template>
</div>
<ng-template #loadingbar>
  <div class="my-5">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</ng-template>